import React, { useState } from "react";
import { Row, Col, Table, Spin, Space, Tooltip, Button, message } from "antd";
import StringHelper from '../../../helpers/StringHelper';
import moment from 'moment-jalaali';
import strings from '../../../../utils/strings';
import CrmCallHistoryModal from "./CrmCallHistoryModal";
import CrmCallReasonModal from "./crmCallReasonModal";
import { ZoomInOutlined } from "@ant-design/icons";
import { useGeneralStore } from "../../../../store/slices/createGeneralSlice";
import { useReportsStore } from "../../../../store/slices/createReportsSlice";

export default function CrmCallHistory({ usrUserID }) {
    const general = useGeneralStore();
    const reports = useReportsStore();
    const [id, setID] = useState();
    const data = reports.crmCallHistory.data;
    const initialloading = reports.crmCallHistory.loading;
    const buttonLoading = reports.crmDoneCallHistory.loading;

    const columns = [
        {
            title: 'مشاهده',
            dataIndex: "operation",
            width: 80,
            key: "operation",
            render: (_, record) =>
                data.length >= 1 && (
                    <Space size="middle">

                        <Button type='link' htmltype="submit"
                            onClick={() => {
                                setID(record.Id)
                                reports.getCrmCallHistoryReason(record.Id);
                                general.ToggleCrmCallReasonModal(true);
                            }}>
                            <ZoomInOutlined />
                        </Button>

                    </Space>
                )
        },
        {
            title: 'روند تماس',
            dataIndex: "doneCall",
            ellipsis: true,
            width: 90,
            key: "doneCall",
            render: (_, record) =>
                data.length >= 1 && (
                    <Space size="middle">
                        {record.CallStatus === 1 &&
                            <button
                                type="primary" htmltype="submit" className="btn btn-success waves-effect waves-light"
                                onClick={() => {
                                    reports.getCrmDoneCallHistory(record.Id);

                                    if (usrUserID) {
                                        setTimeout(() => {
                                            reports.getCrmCallHistory(usrUserID);
                                        }, 1000)
                                    } else message.error("آی دی کاربر یافت نشد")
                                }}>
                                <Tooltip placement="top" overlayClassName="wizard-tooltip" title="بسته">
                                    <i className={`${buttonLoading ? "bx bx-loader bx-spin" : "bx bx-check-double"} "font-size-14 align-middle "`}></i>
                                </Tooltip>
                            </button>}
                    </Space>
                )
        },
        {
            title: 'کد تماس',
            dataIndex: 'Id',
            width: 80,
            render: (text) => StringHelper.getFarsiNum(text)
        },
        {
            title: 'نام کاربری',
            dataIndex: 'UserName',
            width: 120,
            key: 'UserName',

        },

        {
            title: 'دلیل تماس',
            dataIndex: 'ReasonTitle',
            width: 120,
            key: 'ReasonTitle',
            render: text => strings.getFarsiNum(text),
        },
        {
            title: 'وضعیت تماس',
            dataIndex: 'CallStatusTitle',
            width: 110,
            key: 'CallStatusTitle',
        },
        {
            title: 'نوع تماس',
            dataIndex: 'CallTypeTitle',
            width: 100,
            key: 'CallTypeTitle',
            render: text => strings.getFarsiNum(text),
        },
        {
            title: 'تاریخ ثبت',
            dataIndex: 'CreationTime',
            key: 'CreationTime',
            width: 100,
            render: data => data && strings.getFarsiNum(moment(data).format('jYYYY/jMM/jDD'))
        },
        {
            title: "کد رهگیری",
            dataIndex: "TrackingCode",
            key: "TrackingCode",
            width: 120,
            sorter: (a, b) => a.TrackingCode.localeCompare(b.TrackingCode),
        },
        {
            title: "کد درخواست",
            dataIndex: "InsuranceRequestId",
            key: "InsuranceRequestId",
            width: 120,
            sorter: (a, b) => a.InsuranceRequestId.localeCompare(b.InsuranceRequestId),
        },
        {
            title: "توضیحات",
            dataIndex: "Description",
            width: 125,
            key: "Description",
            render: text => <span style={{ color: '#5ec393' }}>{text}</span>,
        },

    ];


    return (
        <Spin spinning={initialloading}>
            <Row
                gutter={[16, 16]}>
                <Col span={24}>
                    <button type="primary" className="btn btn-primary waves-effect waves-light float-left  "
                        onClick={() => general.ToggleCrmCallHistoryModal()}>
                        <i className="fas fa-plus font-size-14 align-middle mr-2"></i> افزودن تماس جدید
                    </button>
                </Col>
                <Col span={24}>

                    <div className="animated fadeIn">
                        <div className="profile-header">
                        </div>
                        <Table
                            style={{ overflowX: 'scroll', width: "100%" }}
                            className="custom-table crm-request-report "
                            showHeader={true}
                            columns={columns}
                            loading={initialloading}
                            scroll={true}
                            pagination={true}
                            dataSource={data}
                            rowKey="Id"
                        />
                        <CrmCallHistoryModal historyCall={true} usrUserID={usrUserID} />
                    </div>
                    <CrmCallReasonModal callHistoryId={id} />
                </Col>
            </Row>
        </Spin>
    );
}
